import { Assets } from 'pixi.js'
import hs_menu_click from '../../../asset/images/menu/menu_click.png'
import hs_menu_hover from '../../../asset/images/menu/menu_hover.png'
import hs_menu_normal from '../../../asset/images/menu/menu_normal.png'
import hs_menu_unable from '../../../asset/images/menu/menu_unable.png'
import { ButtonProps } from './interface/ButtonProps'
import { Button, soundManager, SoundType } from '@slot-nx/core'

Assets.addBundle('HSMenuButton', {
  hs_menu_click: { src: hs_menu_click, loadParser: 'loadTextures' },
  hs_menu_hover: { src: hs_menu_hover, loadParser: 'loadTextures' },
  hs_menu_normal: { src: hs_menu_normal, loadParser: 'loadTextures' },
  hs_menu_unable: { src: hs_menu_unable, loadParser: 'loadTextures' },
})

interface MenuButtonProps extends ButtonProps {
  onPress: () => void
  enabled: boolean
}

export const MenuButton = (props: MenuButtonProps) => {
  return (
    <Button
      name="Menu Button"
      defaultView="hs_menu_normal"
      hoverView="hs_menu_hover"
      pressedView="hs_menu_click"
      disabledView="hs_menu_unable"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      enabled={props.enabled}
      onPressing={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onPress={props.onPress}
    />
  )
}
